import { render } from "./StockagePlaceForm.vue?vue&type=template&id=d7fa977e"
import script from "./StockagePlaceForm.vue?vue&type=script&lang=js"
export * from "./StockagePlaceForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__